import { useEffect, useState } from "react";
import axios from 'axios';
import SportType from "../../common/Enums/SportType";

const useYearGameAchievementsFormatter = (gameId, sportId = 0) => {
  const API_PREFIX = `${location.origin}/api/v1/game`;

  const [formattedAchievements, setFormattedAchievements] = useState(null);
  const [formattedTypes, setFormattedTypes] = useState([]);
  const [error, setError] = useState('');
  const [usesNabps, setUsesNabps] = useState(false);

  const fetchSingle = async (supermatchId, sportsmanId) => {
    try {
      const { data, status } = await axios.get(`${API_PREFIX}/${gameId}/stageAchievements/stage/${supermatchId}/sportsman/${sportsmanId}`);

      if (status == 200) {
        let { achievements, types } = data;
        setFormattedTypes(types);

        let details = [];
        achievements.forEach(function(el) {
          let typeIndex = types.findIndex(obj => obj.id == el.achievement_id);
          // Times is always 1 for tennis and darts
          if (typeIndex > -1) {
            details.push({
              range: null,
              points: parseFloat(el.points),
              times: parseFloat(el.times),
              achievement: types[typeIndex],
              result_id: el.result_id,
              round: el.round,
            });
          }
        })
        setFormattedAchievements(details);
      }
    } catch (err) {
      setFormattedAchievements(null);
      setFormattedTypes([]);
      setError('Failed to fetch achievement details.');
    }
  }

  const fetchFromMatch = async (
    sportsmanAId,
    sportsmanBId,
    rankingClassificationId,
    submatchId,
    sportType = null
  ) => {
    try {
      let fullApi = `${API_PREFIX}/${gameId}/stageAchievements/stage/${rankingClassificationId}/sportsmanA/${sportsmanAId}/sportsmanB/${sportsmanBId}/submatch/${submatchId}`;

      // Refactor, manipulate from backend, use something like shouldUseNbaType
      if (
          [
            SportType.FOOTBALL,
            SportType.AMERICAN_FOOTBALL,
            SportType.BASKETBALL,
          ].includes(sportType)
        ) {
        fullApi = `${API_PREFIX}/${gameId}/stageAchievements/stage/${rankingClassificationId}/sportsmanA/${sportsmanAId}/sportsmanB/${sportsmanBId}`;
      }

      const { data, status } = await axios.get(fullApi);

      if (status == 200) {
        let { sideA, sideB } = data;

        let sideATypes = sideA.types;
        let sideBTypes = sideB.types;

        // For matches with Byes, either side is always empty
        // Make sure to always have value for formattedTypes
        if (sideATypes.length > 0 && sideBTypes.length > 0) {
          // We'll only use some properties of the achievements, so, either sideA and sideB will do regardless of their points value
          setFormattedTypes(sideATypes);
        }

        // use sideB if sideA is empty
        if (sideATypes.length == 0 && sideBTypes.length > 0) {
          setFormattedTypes(sideBTypes);
        }
        // use sideA if sideB is empty
        if (sideBTypes.length == 0 && sideATypes.length > 0) {
          setFormattedTypes(sideATypes);
        }

        let sideADetails = [];
        let sideBDetails = [];
        
        // For Side A
        sideA.achievements.forEach(function(el) {
          let typeIndex = sideATypes.findIndex(obj => obj.id == el.achievement_id);

          if (typeIndex > -1) {
            sideADetails.push({
              range: null,
              points: parseFloat(el.points),
              times: parseFloat(el.times),
              achievement: sideATypes[typeIndex],
              result_id: el.result_id,
              round: el.round,
            });
          }
        });

        // For Side B
        sideB.achievements.forEach(function(el) {
          let typeIndex = sideBTypes.findIndex(obj => obj.id == el.achievement_id);

          if (typeIndex > -1) {
            sideBDetails.push({
              range: null,
              points: parseFloat(el.points),
              times: parseFloat(el.times),
              achievement: sideBTypes[typeIndex],
              result_id: el.result_id,
              round: el.round,
            });
          }
        });

        setFormattedAchievements({
          sideA: sideADetails,
          sideB: sideBDetails,
        });
      }
    } catch (err) {
      setFormattedAchievements(null);
      setFormattedTypes([]);
      setError('Failed to fetch achievement details.');
    }
  }

  const usesNABPS = async (sportId, gameType) => {
    try {
      const { data, status } = await axios.get(`${API_PREFIX}/${gameId}/nabps/`);

      if (status == 200) {
        let usesNabps = data['uses_nabps'];
        let allowedSports = data['allowed_sports'];
        let allowedTypes = data['allowed_game_types'];
        
        setUsesNabps(usesNabps &&
          allowedSports.includes(sportId) &&
          allowedTypes.includes(gameType));

        return;
      }

      setUsesNabps(false);
    } catch (e) {
      console.log(e);
      setUsesNabps(false);
    }
  }

  return {
    formattedAchievements,
    setAchievements: setFormattedAchievements,
    formattedTypes,
    setTypes: setFormattedTypes,
    error,
    fetchSingle: fetchSingle,
    fetchFromMatch: fetchFromMatch,
    fetchNabpsDetails: usesNABPS,
    usesNabps,
  }
}

export default useYearGameAchievementsFormatter;